module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/2/erz-f4731a7b7c9252295e6b0db46704b409.png";